import React from 'react'
import ICLoc from 'assets/icons/ic-loc.png'
import ICLocQanun from 'assets/icons/ic-locQanun.png'
import cx from 'classnames';

export default function List({list,loc,cardPm,qanun}) {
  const spanClasses = cx({
    'xl:font-semibold font-sm text-primary': cardPm ? false : true,
    'hidden': cardPm ? true : false,
  })
  return (
    <div className="flex items-center space-x-2">
      {qanun ? (
        <img src={ICLocQanun} alt={list} width={30} height={30} />
      ) : (
        <img src={ICLoc} alt={list} width={30} height={30} />
      )}
      <span className={spanClasses}>{loc}:</span>
      <div dangerouslySetInnerHTML={{ __html: list }}/>
      {/* <h1
        className="xl:font-semibold font-sm"
        
      >
        {list?.text}
      </h1> */}
    </div>
  );
}
